module.exports = __webpack_public_path__ + "static/media/logo.d249b3fc.png";